/**
 * RoboticButton.jsx
 *
 * Mechanical, angular-cut button with a beveled metallic body, glowing
 * border and a slow light-sheen sweep — the "robotic" button style used
 * everywhere in the redesign (game CTAs, wallet form, footer socials).
 *
 * Props:
 *   children  {ReactNode}
 *   onClick   {function}
 *   variant   {'cyan'|'violet'|'danger'|'ghost'}  default 'cyan'
 *   size      {'sm'|'md'|'lg'}                    default 'md'
 *   disabled  {boolean}
 *   fullWidth {boolean}
 *   sheen     {boolean}  Show the animated light sweep (default true)
 *   type      {string}   Native button type
 *   className {string}
 */
import React from 'react';

const SIZES = {
  sm: 'px-4 py-2 text-xs',
  md: 'px-6 py-3 text-sm',
  lg: 'px-8 py-4 text-base',
};

const VARIANT_CLASS = {
  cyan:   'btn-robotic-cyan',
  violet: 'btn-robotic-violet',
  danger: 'btn-robotic-danger',
  ghost:  'btn-robotic-ghost',
};

export default function RoboticButton({
  children,
  onClick,
  variant = 'cyan',
  size = 'md',
  disabled = false,
  fullWidth = false,
  sheen = true,
  type = 'button',
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn-robotic ${VARIANT_CLASS[variant] || VARIANT_CLASS.cyan} ${SIZES[size]} ${
        fullWidth ? 'w-full' : ''
      } ${className}`}
      {...rest}
    >
      {children}
      {sheen && !disabled && <span className="btn-sheen" aria-hidden="true" />}
    </button>
  );
}
